/*
 * Module for the topic label modal
 */

define(["marionette", "jquery", "messaging/messenger", "./basicKbRoleInfoView"], function (
  Marionette,
  $,
  Messenger,
  BasicKbRoleInfoView,
) {
  var BasicKbRoleInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "basicKbRoleInfoModule";
    },
    show: function (kbRole, kbs) {
      this.model = kbRole;
      if (kbRole.isNew()) {
        this.model.kbs = kbs;
      } else {
        this.model.kbReadOnly = true;
      }

      this.view = new BasicKbRoleInfoView.basicKbRoleInfoView({ model: kbRole });
      this.view.on("click:show:history", function () {
        Messenger.vent.trigger("kbRole:history");
      });
      this.view.on("kbRole:kbId:changed", function (kbId) {
        Messenger.vent.trigger("kbRole:kbId:changed", kbId);
      });
      if (this.model.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#name");
          },
          this,
        );
      }
      this.showRegion(this.view);
    },
    nameError: function (div, errorMessage) {
      this.view.showError(div, errorMessage);
    },
  });

  return BasicKbRoleInfoController;
});
